export default "/images/delete-black.png?95ada2b12f2f60abca08f2a14e43622a";